<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,8C13,8,11,8,11,8C10.84,8,10.690000000000001,7.95,10.559999999999999,7.89C10.559999999999999,7.89,10.559999999999999,7.9,10.559999999999999,7.9C10.559999999999999,7.9,9.54,7.39,9.54,7.39C9.54,7.39,9.17,9.25,9.17,9.25C9.17,9.25,10.55,10.17,10.55,10.17C10.55,10.17,10.54,10.19,10.54,10.19C10.809999999999999,10.36,11,10.65,11,11C11,11,11,15,11,15C11,15.55,10.55,16,10,16C9.45,16,9,15.55,9,15C9,15,9,11.54,9,11.54C9,11.54,7.73,10.69,7.73,10.69C7.73,10.69,5.93,15.36,5.93,15.36C5.93,15.36,5.92,15.36,5.92,15.36C5.779999999999999,15.73,5.43,16,5,16C4.45,16,4,15.55,4,15C4,14.87,4.03,14.75,4.07,14.64C4.07,14.64,4.0600000000000005,14.64,4.0600000000000005,14.64C4.0600000000000005,14.64,7.39,6,7.39,6C7.39,6,5.62,6,5.62,6C5.62,6,4.89,7.45,4.89,7.45C4.89,7.45,4.88,7.45,4.88,7.45C4.72,7.77,4.39,8,4,8C3.45,8,3,7.55,3,7C3,6.84,3.05,6.69,3.11,6.56C3.11,6.56,3.1,6.56,3.1,6.56C3.1,6.56,4.1,4.56,4.1,4.56C4.1,4.56,4.11,4.56,4.11,4.56C4.28,4.23,4.61,4,5,4C5,4,8.16,4,8.16,4C8.16,4,8.45,3.25,8.45,3.25C8.17,2.9,8,2.47,8,2C8,0.9,8.9,0,10,0C11.1,0,12,0.9,12,2C12,3,11.27,3.82,10.309999999999999,3.97C10.309999999999999,3.97,9.809999999999999,5.29,9.809999999999999,5.29C9.809999999999999,5.29,11.24,6,11.24,6C11.24,6,13,6,13,6C13.55,6,14,6.45,14,7C14,7.55,13.55,8,13,8C13,8,13,8,13,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Walk',
} as DefineComponent
</script>
